module.exports = __webpack_public_path__ + "img/walls-left-desktop.714d3f30.png";